export const getInventory = state => state.inventoryContent.inventoryData;
export const getSingleInventory = state => state.inventoryContent.singleInventoryData;
export const getLoading =state => state.inventoryContent.isLoading;
export const getSingleLoading =state => state.inventoryContent.isSingleLoading;
export const getCreateLoading =state => state.inventoryContent.isCreateLoading;
export const getCreatedStatus =state => state.inventoryContent.status;
export const getUpdateStatus =state => state.inventoryContent.updateStatus;
export const getCreatedId =state => state.inventoryContent.createdId;
